"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mandatoryStyles = exports.inputStyles = exports.wrapperStyles = void 0;

var _styledComponents = require("styled-components");

var _polished = require("polished");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var borderedStyles = (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  border: 2px solid ", ";\n"])), function (p) {
  return p.theme.inputBorderRadius;
}, function (p) {
  return p.theme.colorBorder;
});
var wrapperStyles = (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex: 1 1 auto;\n  align-items: center;\n  justify-content: flex-start;\n  border-bottom: 2px solid ", ";\n  background: ", ";\n\n  ", ";\n\n  ", ";\n  ", ";\n"])), function (p) {
  return p.theme.colorBorder;
}, function (p) {
  return p.theme.inputBackground;
}, function (p) {
  return p.theme.inputBorderStyle === "full" && borderedStyles;
}, function (p) {
  return p.isFocused && "border-color: ".concat((0, _polished.darken)(0.1, p.theme.colorBorder));
}, function (p) {
  return p.isError && "border-color: ".concat(p.theme.colorDanger, ";");
});
exports.wrapperStyles = wrapperStyles;
var inputStyles = (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n  font-weight: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  font-style: ", ";\n  padding: 1rem 0;\n  ", ";\n  border: 0;\n  background: transparent;\n  opacity: 1;\n\n  &:disabled {\n    opacity: 1;\n    color: ", ";\n    -webkit-text-fill-color: ", ";\n    cursor: not-allowed;\n  }\n"])), function (p) {
  return p.theme.inputFontWeight;
}, function (p) {
  return p.theme.inputFontSize;
}, function (p) {
  return p.theme.inputFontFamily || "inherit";
}, function (p) {
  return p.theme.inputFontStyle;
}, function (p) {
  return p.theme.inputBorderStyle === "full" && !p.hasPrefix && !p.isMandatory ? "padding-left: 1rem;" : "padding-left: 0.25rem";
}, function (p) {
  return p.theme.colorLabel;
}, function (p) {
  return p.theme.colorLabel;
});
exports.inputStyles = inputStyles;
var mandatoryStyles = (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex: 0 0 auto;\n  margin-left: 1rem;\n  transform: translateY(2px);\n  font-size: 1rem;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: 600;\n  color: ", ";\n"])), function (p) {
  return p.theme.fontFamilyDefault;
}, function (p) {
  return p.theme.colorPrimary;
});
exports.mandatoryStyles = mandatoryStyles;